import { Popover, PopoverSurface, PopoverTrigger } from '@fluentui/react-components'
import { ReactElement, ReactNode, useState } from 'react'

type ComposedPopoverProps = {
  trigger: ReactElement
  children: ReactNode
  isOpen?: boolean
  setIsOpen?: (isOpen: boolean) => void
}

export function ComposedPopover(props: ComposedPopoverProps) {
  const [isOpenState, setIsOpenState] = useState(false)
  const isOpen = props.isOpen ?? isOpenState
  const setIsOpen = props.setIsOpen ?? setIsOpenState
  return (
    <Popover positioning="below" open={isOpen} onOpenChange={(_event, data) => setIsOpen(data.open)}>
      <PopoverTrigger disableButtonEnhancement>{props.trigger}</PopoverTrigger>
      <PopoverSurface tabIndex={-1} className="w-72 !bg-grey-lightest !p-2">
        {props.children}
      </PopoverSurface>
    </Popover>
  )
}
